import {
  ADD_BILLING_ADDRESS_REQUEST,
  ADD_BILLING_ADDRESS_SUCCESS,
  ADD_BILLING_ADDRESS_FAILURE,
  RESET_BILLING_ADDRESS_STATE,
  UPDATE_BILLING_ADDRESS_SUCCESS,
  UPDATE_BILLING_ADDRESS_FAILURE,
  UPDATE_BILLING_ADDRESS_REQUEST,
  FETCH_BILLING_ADDRESS_REQUEST,
  FETCH_BILLING_ADDRESS_SUCCESS,
  FETCH_BILLING_ADDRESS_FAILURE,
  VIEW_BILLING_ADDRESS_REQUEST,
  VIEW_BILLING_ADDRESS_SUCCESS,
  VIEW_BILLING_ADDRESS_FAILURE,
  DELETE_BILLING_ADDRESS_SUCCESS,
  DELETE_BILLING_ADDRESS_FAILURE,
  DELETE_BILLING_ADDRESS_REQUEST,
} from './BillingAddressTypes';

const initialState = {
  loading: false,
  data: null,
  updateLoading: false,
  deleteLoading: false,
  address: null,
  currentAddress: null,
  success: false,
  error: null,
  addresses: [],
};

const BillingAddressReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BILLING_ADDRESS_REQUEST:
      return {
        ...state,
        loading: true,
        updateLoading: false,
        success: false,
        error: null,
      };

    case ADD_BILLING_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        updateLoading: false,
        address: action.payload || action.payload,
        error: null,
      };

    case ADD_BILLING_ADDRESS_FAILURE:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        success: false,
        error: action.payload,
      };

    case FETCH_BILLING_ADDRESS_REQUEST:
      return { ...state, loading: true, updateLoading: false, error: null };

    case FETCH_BILLING_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateLoading: false,

        addresses: action.payload,
      };

    case FETCH_BILLING_ADDRESS_FAILURE:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        error: action.payload,
      };

    case VIEW_BILLING_ADDRESS_REQUEST:
      return { ...state, loading: true, success: false, updateLoading: false };

    case UPDATE_BILLING_ADDRESS_REQUEST:
      return { ...state, loading: false, success: false, updateLoading: true };

    case VIEW_BILLING_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        data: action.payload,
      };

    case UPDATE_BILLING_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        updateLoading: false,
        currentAddress: action.payload,
      };

    case VIEW_BILLING_ADDRESS_FAILURE:
    case UPDATE_BILLING_ADDRESS_FAILURE:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        error: action.payload,
      };
    case DELETE_BILLING_ADDRESS_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        error: null,
      };

    case DELETE_BILLING_ADDRESS_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        success: true,
        addresses: state.addresses.filter(
          (address) => address.id !== action.payload
        ),
      };

    case DELETE_BILLING_ADDRESS_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        success: false,
        error: action.payload,
      };

    case RESET_BILLING_ADDRESS_STATE:
      return { ...initialState };

    default:
      return state;
  }
};

export default BillingAddressReducer;
